import configJson from './auth_config.json'

export function getConfig() {
  const domain = process.env.REACT_APP_AUTH0_DOMAIN || configJson.domain
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID || configJson.clientId
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE ?? configJson.audience

  return {
    domain,
    clientId,
    ...(audience && { audience }),
  }
}
